import { Directive, inject } from '@angular/core';
import { LocationService } from '@app/core/services/location.service';
import { AutoComplete, AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { concatMap, map, groupBy, mergeMap, zip, of, toArray, switchMap } from 'rxjs';

@Directive({
  selector: '[appLocationAutocomplete]',
  standalone: true
})
export class LocationAutocompleteDirective {
  private _hostComponent = inject(AutoComplete);
  private _locationService = inject(LocationService);

  constructor() {
    this._hostComponent.completeMethod
      .asObservable()
      .pipe(switchMap((x) => this.searchGoupedLocations(x)))
      .subscribe((locations) => (this._hostComponent.suggestions = locations));
  }

  searchGoupedLocations(event: AutoCompleteCompleteEvent) {
    return this._locationService.search(event.query).pipe(
      concatMap((arr) => arr),
      map((x) => {
        const label = `${x.referenceCode} - ${x.name}`;
        return {
          selectedLabel: label,
          optionLabel: label.replace(new RegExp(event.query, 'gi'), (match) => `<strong>${match}</strong>`),
          countryCode: x.countryCode,
          countryName: x.countryName,
          uid: x.uid
        };
      }),
      groupBy((loc) => loc.countryCode.toLocaleLowerCase()),
      mergeMap((group) => zip(of(group.key), group.pipe(toArray()))),
      map(([key, items]) => ({
        countryName: this.highlightPrefix(items[0].countryName, event.query),
        flagIcon: `fi fi-${key}`,
        items: items
      })),
      toArray()
    );
  }

  private highlightPrefix(value: string, query: string): string {
    if (!query || !value.toLocaleLowerCase().startsWith(query.toLocaleLowerCase())) return value;
    return `<strong>${value.slice(0, query.length)}</strong>${value.slice(query.length)}`;
  }
}
